export interface CasinoGameItem {
  id: string;
  name: string;
  icon: string;
  description: string;
  path: string | null;
  comingSoon: boolean;
}

export const CASINO_GAMES: CasinoGameItem[] = [
  { id: 'slots', name: 'Lucky 7', icon: '🎰', description: 'Kolikkopeli', path: '/game/slots', comingSoon: false },
  { id: 'dice', name: 'Noppa', icon: '🎲', description: 'Yli / alle 7', path: '/game/dice', comingSoon: false },
  { id: 'roulette', name: 'Ruletti', icon: '🎡', description: 'Punainen / Musta', path: '/game/roulette', comingSoon: false },
  { id: 'wheel', name: 'Onnenpyörä', icon: '🪐', description: 'Pyöräytä pyörä', path: '/game/wheel', comingSoon: false },
  { id: 'blackjack', name: 'Blackjack', icon: '🃏', description: '21', path: '/game/blackjack', comingSoon: false },
  { id: 'scratch', name: 'Arpalappu', icon: '🎫', description: 'Raapaise ja voita', path: '/game/scratch', comingSoon: false },
  { id: 'baccarat', name: 'Baccarat', icon: '♦️', description: 'Pankkiiri vs pelaaja', path: null, comingSoon: true },
  { id: 'keno', name: 'Keno', icon: '🔢', description: 'Valitse numerot', path: null, comingSoon: true },
  { id: 'poker', name: 'Video Poker', icon: '🂡', description: 'Pokerikäsi', path: null, comingSoon: true },
  { id: 'craps', name: 'Craps', icon: '⚃', description: 'Noppapeli', path: null, comingSoon: true },
  { id: 'bingo', name: 'Bingo', icon: '🔔', description: 'Bingopelit', path: null, comingSoon: true },
  { id: 'slots2', name: 'Fruit Mania', icon: '🍒', description: 'Hedelmäslotti', path: null, comingSoon: true },
  { id: 'slots3', name: 'Diamond', icon: '💎', description: 'Jalokivislotti', path: null, comingSoon: true },
  { id: 'hilo', name: 'High Low', icon: '📈', description: 'Korkeampi / matalampi', path: null, comingSoon: true },
  { id: 'mines', name: 'Miinat', icon: '💣', description: 'Vältä miinoja', path: null, comingSoon: true },
];
